export default "__VITE_ASSET__DAKuSIwy__"